export const all_routes = {
  dealsDashboard: "/dashboard/crm-dashboard",
  leadsDashboard: "/dashboard/leads-dashboard",
  projectDashboard: "/dashboard/project-dashboard",
  newDashboard: "/dashboard/new-dashboard",
  revenueSummary: "/dashboard/revenue-summary",
  salesSummary: "/dashboard/sales-summary",
  analytics: "/dashboard/analytics",
  analyticsActivitiesReport: "/dashboard/activities-report",
  analyticsChatAnalytics: "/dashboard/chat-analytics",
  customAnalytics: "/custom/analytics",

  superadminDashboard: "/super-admin/dashboard",
  superadminCompany: "/super-admin/company",
  superadminSubscription: "/super-admin/subscription",
  superadminPackagelist: "/super-admin/packages",
  superadminPackageGrid: "/super-admin/packages-grid",
  superadminDomain: "/super-admin/domain",
  superadminPurchaseTransaction: "/super-admin/purchase-transaction",

  platformAnalystDashboard: "/super-admin/dashboard",
  platformAnalystCompany: "/super-admin/company",
  platformAnalystSubscription: "/super-admin/subscription",
  platformAnalystPackagelist: "/super-admin/packages",
  platformAnalystPackageGrid: "/super-admin/packages-grid",
  platformAnalystDomain: "/super-admin/domain",
  platformAnalystPurchaseTransaction: "/super-admin/purchase-transaction",

  activityCalls: "/activity-calls",
  activityMail: "/activity-mail",
  activityTask: "/activity-task",
  activityMeeting: "/activity-meeting",
  activities: "/activities",
  payments: "/payments",
  email: "/application/email/inbox",
  emailImportant: "/application/email/important",
  emailSent: "/application/email/sent",
  emailDraft: "/application/email/draft",
  emailSpam: "/application/email/spam",
  emailTrash: "/application/email/trash",
  emailFolder: "/application/email/folder/:folderId",
  emailDetail: "/application/email/:section/:id",
  chat: "/application/chat",
  calendar: "/application/calendar",
  externalTasks: "/application/tasks",
  tasks: "/tasks",
  tasksImportant: "/tasks-important",
  tasksCompleted: "/tasks-completed",
  campaign: "/campaign",
  campaignComplete: "/campaign-complete",
  campaignArchieve: "/campaign-archieve",
  addCampaign: "/addCampaign",
  contactDetails: "/contacts/:id",
  deals: "/deals",
  dealsList: "/deals/list",
  dealsDetails: "/deals/:id",
  dealsKanban: "/deals-kanban",
  contactList: "/contacts",
  leadsKanban: "/leads-kanban",
  pipelines: "/pipelines",
  pipelinesList: "/pipelines/list",
  pipelinesGrid: "/pipelines/grid",
  pipelinesKanban: "/pipelines/kanban",
  pipelineDetails: "/pipelines/:id",
  projects: "/projects",
  companyDetails: "/companies/:id",
  projectDetails: "/project-details",
  contactGrid: "/contact-grid",
  companiesGrid: "/companies-grid",
  compaignComplete: "/compaign-complete",
  companies: "/companies",
  tenantManagement: "/settings/tenant-management",
  accessManagement: "/access-management",
  userManagement: "/access-management/user-management",
  userManagementSuperAdmin: "/super-admin/user-management",
  teamManagement: "/access-management/team-management",
  leads: "/leads",
  leadsList: "/leads/list",
  leadsGrid: "/leads/grid",
  leadDetails: "/leads/:id",
  projectsGrid: "/project-grid",
  proposals: "/proposals",
  proposalsList: "/proposals/list",
  proposalsGrid: "/proposals/grid",
  proposalsDetails: "/proposals/:id",
  contracts: "/contracts",
  contractsList: "/contracts/list",
  contractsGrid: "/contracts/grid",
  contractsDetails: "/contracts/:id",
  ContractsList: "/contracts-list",
  ContractsGrid: "/contracts-grid",
  InvoiceList: "/invoice-list",
  InvoiceGrid: "/invoice-grid",
  estimationList: "/estimation-list",
  estimationKanban: "/estimation-kanban",

  bankAccounts: "/bank-accounts",
  blankPage: "/blank-page",
  dataTables: "/data-tables",
  tablesBasic: "/tables-basic",
  notes: "/notes",
  comingSoon: "/coming-soon",

  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  accountVerification: "/account-verification",
  accountVerificationWithToken: "/account-verification/:token",
  success: "/success",
  emailVerification: "/email-verification",
  emailConnection: "/email-connection",
  socialConnection: "/social-connection",
  lockScreen: "/lock-screen",
  resetPassword: "/reset-password",
  resetPasswordWithToken: "/reset-password/:token",

  alert: "/ui-alert",
  accordion: "/ui-accordion",
  avatar: "/ui-avatar",
  badges: "/ui-badges",
  border: "/ui-border",
  breadcrums: "/ui-breadcrums",
  button: "/ui-buttons",
  buttonGroup: "/ui-button-group",
  cards: "/ui-cards",
  carousel: "/ui-carousel",
  colors: "/ui-colors",
  dropdowns: "/ui-dropdowns",
  grid: "/ui-grid",
  images: "/ui-images",
  lightbox: "/ui-lightbox",
  media: "/ui-media",
  modals: "/ui-modals",
  navTabs: "/ui-navtabs",
  offcanvas: "/ui-offcanvas",
  pagination: "/ui-pagination",
  placeholder: "/ui-placeholder",
  popover: "/ui-popover",
  progress: "/ui-progress",
  rangeSlider: "/ui-rangeslider",
  spinner: "/ui-spinner",
  sweetalert: "/ui-alert",
  toasts: "/ui-toasts",
  tooltip: "/ui-tooltip",
  typography: "/ui-typography",
  video: "/ui-video",
  clipboard: "/ui-clipboard",
  counter: "/ui-counter",
  dragandDrop: "/ui-drag-drop",
  rating: "/ui-rating",
  ribbon: "/ui-ribbon",
  stickyNotes: "/ui-sticky-notes",
  textEditor: "/ui-text-editor",
  timeLine: "/ui-timeline",
  scrollBar: "/ui-scrollbar",
  apexChat: "/ui-apexchat",
  chart: "/ui-chartjs",
  featherIcons: "/ui-feather-icon",
  falgIcons: "/ui-flag-icon",
  fantawesome: "/ui-fantawesome",
  materialIcon: "/ui-material-icon",
  pe7icon: "/ui-icon-pe7",
  simpleLineIcon: "/ui-simpleline",
  themifyIcon: "/ui-themify",
  typicon: "/ui-typicon",
  weatherIcon: "/ui-weather-icon",
  basicInput: "/forms-basic-input",
  checkboxandRadion: "/form-checkbox-radios",
  inputGroup: "/form-input-groups",
  gridandGutters: "/form-grid-gutters",
  formSelect: "/form-select",
  formMask: "/form-mask",
  fileUpload: "/form-fileupload",
  horizontalForm: "/form-horizontal",
  verticalForm: "/form-vertical",
  floatingLable: "/form-floating-labels",
  formValidation: "/form-validation",
  reactSelect: "/select",
  formWizard: "/form-wizard",
  dataTable: "/tables-basic",
  tableBasic: "/data-tables",
  iconicIcon: "/icon-ionic",

  uiAlerts: "/ui-alerts",
  uiAccordion: "/ui-accordion",
  uiAvatar: "/ui-avatar",
  uiBadges: "/ui-badges",
  uiBorders: "/ui-borders",
  uiButtons: "/ui-buttons",
  uiButtonsGroup: "/ui-buttons-group",
  uiBreadcrumb: "/ui-breadcrumb",
  uiCards: "/ui-cards",
  uiCarousel: "/ui-carousel",
  uiColor: "/ui-color",
  uiDropdowns: "ui-dropdowns",
  swiperjs: "/ui-swiperjs",
  sortable: "/ui-sortable",
  tablericons: "/icon-tabler",
  bootstrapicons: "/icon-bootstrap",
  remixicons: "/icon-remix",
  formpicker: "/form-pickers",
  mapleaflet: "/maps-leaflet",

  error404: "/error-404",
  error500: "/error-500",
  underMaintenance: "/under-maintenance",

  dealssettings: "/lifecycle-settings/Deals",
  leadssettings: "/lifecycle-settings/Leads",
  pipelinesettings: "/lifecycle-settings/Pipeline",
  proposalssettings: "/lifecycle-settings/Proposals",
  contractssettings: "/lifecycle-settings/Contracts",

  sourceSettings: "/source-configuration/source",
  salesActivityType: "/settings/activity-types",
  lifecycleStatusReasonLost: "/lifecycle-status-reason/lost-reasons",
  lifecycleStatusReasonWon: "/lifecycle-status-reason/won-reasons",

  bankAccount: "/financial-settings/bank-ccount",
  currencies: "/financial-settings/currencies",

  taxRates: "/financial-settings/tax-rates",

  connectedApps: "/general-settings/connected-apps",
  notification: "/general-settings/notification",
  profile: "/general-settings/profile",
  security: "/general-settings/security",
  settings: "/settings",
  generalSettings: "/general-settings",

  notificationSettings: "/general-settings/notification-settings",
  taskNotificationSettings: "/general-settings/notification-settings/task",
  expirationNotificationSettings: "/general-settings/notification-settings/expiration",
  notificationSettingsLeads: "/general-settings/notification-settings/leads",
  notificationSettingsPipelines: "/general-settings/notification-settings/pipelines",
  notificationSettingsDeals: "/general-settings/notification-settings/deals",
  notificationSettingsProposals: "/general-settings/notification-settings/proposals",
  notificationSettingsContracts: "/general-settings/notification-settings/contracts",

  subscriptionmanagement: "/subscription/subscription-management",
  storage: "/other-settings/storage",

  emailSettings: "/integration-settings/email-settings",
  chatSettings: "/integration-settings/chat-settings",
  calendarSettings: "/integration-settings/calendar-settings",
  apiIntegrationSettings: "/integration-settings/api-integration",
  adminApiIntegrationSettings: "/admin-api-integration",
  autoCreationRules: "/integration-settings/auto-creation-rules",

  smsGateways: "/system-settings/sms-gateways",

  appearance: "/website-settings/appearance",
  companySettings: "/settings/organization-settings",
  productServices: "/settings/product-services",
  customFields: "/settings/custom-fields",
  auditLog: "/settings/audit-log",
  approvalPolicy: "/settings/approval-policy",
  workflowConfiguration: "/workflow-configuration",


  language: "/website-settings/language",
  localization: "/settings/localization-settings",
  preference: "/website-settings/preference",
  prefixes: "/website-settings/prefixes",
  languageWeb: "/website-settings/language-web",

  apiDocumentation: "/api/docs",

  importSettings: "/import/import-settings",
  importData: "/import/import-data",

  companyReports: "/reports/company-reports",
  contactReports: "/reports/contact-reports",
  dealReports: "/reports/deal-reports",
  leadReports: "/reports/lead-reports",
  projectReports: "/reports/project-reports",
  taskReports: "/reports/task-reports",
  todo: "/application/todo",

  videoCall: "/application/video-call",
  audioCall: "/application/audio-call",
  callHistory: "/application/call-history",
  fileManager: "/application/file-manager",
  socialfeed: "/application/social-feed",
  kanbanview: "/application/kanban-view",
  invoice: "/application/invoice",
  invoice_details: "/application/invoice-details",

  sources: "-setting/sources",
  contactStage: "-setting/contact-stage",
  industry: "-setting/industry",
  calls: "-setting/calls",
  lostReason: "-setting/lost-reason",

  pages: "/content/pages",
  cities: "/content/cities",
  states: "/content/states",
  testimonials: "/content/testimonials",
  countries: "/content/countries",
  faq: "/content/faq",

  deleteRequest: "/user-management/delete-request",
  rolesPermissions: "/user-management/roles-permissions",
  manageusers: "/user-management/manage-users",
  permissions: "/user-management/permissions",

  contactMessages: "/support/contact-messages",
  tickets: "/support/tickets",

  membershipplan: "/membership-plans",
  membershipAddon: "/membership-addons",
  membershipTransaction: "/membership-transactions",

  layoutMini: "/layout-mini",
  HorizontalSingle: "/layout-horizontal-single",
  WithoutHeader: "/layout-without-header",
  layoutRtl: "/layout-rtl",
  Detached: "/layout-detached",
  Dark: "/layout-dark",
  redirectPage: "/redirect-page",

  aiConfiguration: "/ai-configuration",
  aiConfigurationCrmLevel: "/ai-configuration/crm-level",
  aiConfigurationTenantLevel: "/ai-configuration/tenant-level",
  aiConfigurationUsageLogs: "/ai-configuration/usage-logs",
};
